import { apiConstants } from '../config';
let code = apiConstants.code;
let codeAPI = apiConstants.codeAPI;
const state = {
    error: null,
    loading: false,
    data: {
        code: code,
        codeAPI: codeAPI,
        module: {},
        panels: {
            home: {
                acl: {
                    view: 'MB_00582',
                    add: 'MB_00335',
                    showDirectEditModal: 'MB_00640',
                },
                url: {
                    getMapFeatures: `${codeAPI}/front/map/features`,
                },
            },
            headernav: {
                tools: [
                    {component: 'dashboard', title: 'dashboard.title'},
                    {component: 'accountable', title: 'accountable.title'},
                    {component: 'activity', title: 'activity.title'},
                    {component: 'overdue', title: 'overdue.title'},
                ]
            },
        },
        tools: {
            attribution: {
                active: false,
            },
            scaleline: {
                active: false,
            },
            scalebox: {
                active: false,
            },
            mouseposition: {
                active: false,
            },
            layerswitcher: {
                acl: {
                    view: 'MB_00611',
                },
            },
            streetview: {
                acl: {
                    view: 'MB_00574',
                },
            },
            annotations: {
                active: false,
                acl: {
                    view: 'MB_00641',
                },
            },
            measure: {
                active: false,
                acl: {
                    view: 'MB_00642',
                },
            },
            backoffice: {
                active: true,
                title: 'backoffice.titles',
                label: 'backoffice.label',
                panel: {
                    show: false,
                },
                acl: {
                    view: 'MB_00575', // Nâo deveria ser o MB_00006??
                },
                url: {
                    view: `:moduleCodegestao.home`,
                }
            },
            catalog: {
                active: false,
                acl: {
                    view: 'MB_00638',
                },
            },
            identify: {
                active: false,
                acl: {
                    view: 'MB_00639',
                },
            },
            layers: {
                active: true,
                title: 'layers.titles',
                label: 'layers.label',
                panel: {
                    show: false,
                    loaded: false,
                },
                acl: {
                    view: 'MB_00331',
                },
                url: {
                    getLayers: `${codeAPI}/front/map/layers`,
                },
                selected: null,
            },
            dashboard: {
                active: true,
                panel: {
                    show: false,
                    loaded: false,
                },
                acl: {
                    view: 'MB_00573',
                },
            },
            print_visible_emissions: {
                active: false,
                title: 'print_visible_emissions.titles',
                label: 'print_visible_emissions.label',
                panel: {
                    show: false,
                    loaded: false,
                },
                acl: {
                    view: 'MB_00643',
                },
                url: {
                    capabilitiesPrint: `${codeAPI}/front/print/visible/capabilities`,
                    createPrint: `${codeAPI}/front/print/visible`,
                    getStatusPrint: `${codeAPI}/front/print/visible/job/:id`,
                }
            },
            filtertype: {
                active: true,
                panel: {
                    show: true,
                    collapsed: true,
                    height: 0,
                },
                acl: {
                    view: 'MB_00610',
                },
                url: {

                },
            },
            filterstatus: {
                active: true,
                panel: {
                    show: false,
                },
                acl: {
                    view: 'MB_00609',
                },
                url: {

                },
            },
            activity: {
                active: true,
                title: "activity.title",
                panel: {
                    show: false,
                    loaded: false,
                    reload: false,
                    titleTemplate: "activity.tooltip",
                    txtNoRecords: "activity.no_records",
                    summary: [],
                    toggles: [
                        { id: 1, key: 'started', name: "activity.toggles.submitted.title", },
                        { id: 2, key: 'finished', name: "activity.toggles.completed.title", },
                    ],
                    reloadBtn: true,
                },
                acl: {
                    view: 'MB_00572',
                },
                url: {
                    getData: `${codeAPI}/occurrences/data/activity`,
                },
            },
            overdue: {
                active: true,
                title: "overdue.title",
                panel: {
                    show: false,
                    loaded: false,
                    reload: false,
                    titleTemplate: "overdue.tooltip",
                    txtLoadMoreRecords: "overdue.load_more_records",
                    txtNoRecords: "overdue.no_records",
                    summary: [],
                    reloadBtn: true,
                },
                acl: {
                    view: 'MB_00632',
                },
                url: {
                    getData: `${codeAPI}/occurrences/data/overdue`,
                },
            },
            search: {
                active: true,
                title: "search.title",
                label: "search.label",
                panel: {
                    show: false,
                    loaded: false,
                    reload: false,
                    allowExportData: true,
                    formatExportData: 'xls',
                },
                acl: {
                    view: 'MB_00613',
                    viewPrivate: 'MB_00633',
                    viewAll: 'MB_00618',
                    viewDetails: 'MB_00583',
                    export: 'MB_00631',
                },
                url: {
                    searchAll: `${codeAPI}/occurrences/search`,
                    getLists: `${codeAPI}/occurrences/search/lists`,
                    getSubTypes: `${codeAPI}/occurrences/search/subtypes/:type`,
                    searchUser: `${codeAPI}/occurrences/search/user?q=:query`,
                    export: `${codeAPI}/occurrences/search/export`,
                    job: `${codeAPI}/occurrences/search/export/job/:id`,
                },
            },
            report: {
                active: true,
                title: "report.title",
                panel: {
                    show: false,
                    loaded: false,
                    reports: {
                        globalstatus: {
                            title: 'reports.global_status.title',
                            allowExportData: true,
                            formatExportData: 'xls',
                            url: {
                                data: `${codeAPI}/reports/occurrences/totalizer-status`,
                                export: `${codeAPI}/reports/occurrences/totalizer-status/export`,
                                job: `${codeAPI}/reports/occurrences/export/job/:id`,
                            }
                        },
                        monthlySummary: {
                            title: 'reports.monthly_summary.title',
                            allowExportData: true,
                            formatExportData: 'xls',
                            url: {
                                data: `${codeAPI}/reports/occurrences/montly-resume`,
                                export: `${codeAPI}/reports/occurrences/montly-resume/export`,
                                job: `${codeAPI}/reports/occurrences/export/job/:id`,
                            }
                        },
                        performerSummary: {
                            title: 'reports.performer_summary.title',
                            allowExportData: true,
                            formatExportData: 'xls',
                            url: {
                                data: `${codeAPI}/reports/occurrences/occurrences-performer`,
                                export: `${codeAPI}/reports/occurrences/occurrences-performer/export`,
                                job: `${codeAPI}/reports/occurrences/export/job/:id`,
                            }
                        },
                        occurrencesSummary: {
                            title: 'reports.occurrences_summary.title',
                            allowExportData: true,
                            formatExportData: 'xls',
                            url: {
                                data: `${codeAPI}/reports/occurrences/occurrences-summary`,
                                export: `${codeAPI}/reports/occurrences/occurrences-summary/export`,
                                job: `${codeAPI}/reports/occurrences/export/job/:id`,
                            }
                        },
                        statusChart: {
                            title: 'reports.status_chart.title',
                            allowExportData: true,
                            formatExportData: 'xls',
                            url: {
                                data: `${codeAPI}/reports/occurrences/chart-status`,
                                export: `${codeAPI}/reports/occurrences/chart-status/export`,
                                job: `${codeAPI}/reports/occurrences/export/job/:id`,
                            }
                        },
                        subtypeChart: {
                            title: 'reports.subtype_chart.title',
                            allowExportData: true,
                            formatExportData: 'xls',
                            url: {
                                data: `${codeAPI}/reports/occurrences/chart-subtypes`,
                                export: `${codeAPI}/reports/occurrences/chart-subtypes/export`,
                                job: `${codeAPI}/reports/occurrences/export/job/:id`,
                            }
                        },
                    },
                },
                acl: {
                    view: 'MB_00332',
                    export: 'MB_00332',
                },
                url: {
                    getTypes: `${codeAPI}/occurrences/report/types/:withsubtype`,
                    getStatuses: `${codeAPI}/occurrences/report/statuses`,
                },
            },
            navsearch: {
                active: true,
                panel: {
                    show: true,
                    showDefault: true,
                    categories: [{
                        'id': 'addr',
                        'name': 'navsearch.address.title',
                        'url': '../gateway/address/search/:query',
                        'listGroup': 'adminName1',
                        'labelTemplate': 'navsearch.address.labelTemplate',
                        'subLabelTemplate': null,
                        'placeholder': 'navsearch.address.placeholder'
                    },
                    {
                        'id': 'mb-oco',
                        'name': 'navsearch.occurrence.title',
                        'url': `${codeAPI}/occurrences/search/code/:query`,
                        'labelTemplate': '${code}',
                        'placeholder': 'navsearch.occurrence.placeholder',
                        'showDetail': true,
                        'acl': 'MB_00637',
                    }],
                    search: {
                        category: null,
                        query: null,
                    },
                },
            },
            viewfeature: {
                active: false,
                title: 'occurrence.show_title',
                panel: {
                    show: false,
                    loaded: false,
                    enableEdocLink: false,
                    closeAfterCloseEdit: true,
                },
                acl: {
                    view: 'MB_00583',
                    edit: 'MB_00570',
                    delete: 'MB_00340',
                    notify: 'MB_00357',

                    viewPriority: 'MB_00601',
                    viewUnity: 'MB_00614',
                    viewVisibility: 'MB_00612',
                    viewInternalData: 'MB_00451',
                    viewOriginalDescription: 'MB_00607',
                    viewDescription: 'MB_00608',
                    viewChannel: 'MB_00600',
                    viewHistory: 'MB_00341',
                    viewType: 'MB_00603',
                    viewSubType: 'MB_00604',
                    viewUserInfo: 'MB_00352',
                    viewEdocLink: 'MB_00622',
                },
                url: {
                    show: `${codeAPI}/occurrences/show/:code`,
                    showAnonymous: `${codeAPI}/occurrences/front/:code`,
                    follow: `${codeAPI}/occurrences/follow/:id`,
                },
            },
            editfeature: {
                active: false,
                title: 'occurrence.edit_title',
                panel: {
                    show: false,
                    loaded: false,
                    enableEdocLink: false,
                    showUserInitially: false,
                    closeAfterSave: true,
                    closeAfterNotification: true,
                },
                acl: {
                    view: 'MB_00583',
                    edit: 'MB_00570',
                    delete: 'MB_00340',
                    notify: 'MB_00357',

                    viewHistory: 'MB_00341',
                    // enableVisibility: 'MB_00354',
                    updateVisibility: 'MB_00358',
                    updatePriority: 'MB_00343',
                    updateChannel: 'MB_00342',
                    updateState: 'MB_00344',
                    updateType: 'MB_00345',
                    updateSubType: 'MB_00346',
                    updateUnity: 'MB_00351',
                    updateAssignedTo: 'MB_00375',
                    updateAddress: 'MB_00347',
                    updateReferencePoint: 'MB_00348',
                    updateOriginalDesc: 'MB_00571',
                    updateDescription: 'MB_00349',
                    updatePhotos: 'MB_00350',
                    updateEdocLink: 'MB_00356',
                    viewEdocLink: 'MB_00622',
                    updateAll: 'MB_00339',
                },
                url: {
                    show: `${codeAPI}/occurrences/data/:code`,
                    update: `${codeAPI}/occurrences/:id`,
                    delete: `${codeAPI}/occurrences/:id`,
                    getLists: `${codeAPI}/occurrences/update/lists`,
                    getSubTypes: `${codeAPI}/occurrences/update/subtypes/:type`,
                    getUnitsBySubtype: `${codeAPI}/occurrences/update/unities/subtypes/:subtype`,
                    getNotificationTemplates: `${codeAPI}/occurrences/notifications/manual/form/1`,
                    getSendNotification: `${codeAPI}/occurrences/notifications/manual/send`,
                },
            },
            addfeature: {
                active: true,
                title: 'occurrence.add_title',
                panel: {
                    show: false,
                    loaded: false,
                    infoAddFeature: 'occurrence.form.msg.add.help',
                    infoNoPermissionAddFeature: 'occurrence.form.msg.add.not_allowed',
                    infoOutsideAddFeature: 'occurrence.form.msg.add.out_boundary',
                    infoAtiveFilterFeature: 'occurrence.form.msg.add.active_filter',
                },
                acl: {
                    view: 'MB_00335',
                    allowChannel: 'MB_00353',
                    allowSubType: 'MB_00376',
                    allowVisibility: 'MB_00354',
                    allowPhotos: 'MB_00337',
                    allowReportFrom: 'MB_00336',
                    allowReportFromUpdateUser: 'MB_00615',
                    allowReportFromNewUser: 'MB_00338',
                },
                url: {
                    create: `${codeAPI}/occurrences`,
                    getTypes: `${codeAPI}/occurrences/store/types/:withsubtype`,
                    getChannels: `${codeAPI}/occurrences/store/channels`,
                    searchUser: `${codeAPI}/occurrences/store/search/user?q=:query`,
                    createUser: `${codeAPI}/occurrences/store/user`,
                    updateUser: `${codeAPI}/occurrences/store/user/:id`,
                    reverseAddress: `../gateway/address/reverse/:lat/:lon/:srid`,
                },
            },
            notifyfeature: {
                active: true,
                title: 'occurrence.notify_title',
                panel: {
                    show: false,
                    loaded: false,
                },
                acl: {
                    view: 'MB_00357',
                },
                url: {
                    getNotificationTemplates: `${codeAPI}/occurrences/notifications/manual/form/1`,
                    getSendNotification: `${codeAPI}/occurrences/notifications/manual/send`,
                },
            },
            accountable: {
                active: true,
                title: "accountable.title",
                panel: {
                    show: false,
                    loaded: false,
                    reload: false,
                    data: [],
                    toggles: [
                        {id: 1, key: 'my', name: "accountable.toggles.mine.title", expanded: false},
                        {id: 2, key: 'assigned_me', name: "accountable.toggles.assigned_me.title", expanded: false},
                        {id: 3, key: 'my_unity', name: "accountable.toggles.my_unity.title", expanded: false},
                    ],
                    reloadBtn: true,
                },
                acl: {
                    view: 'MB_00630',
                },
                url: {
                    getData: `${codeAPI}/occurrences/data/accountable`,
                },
            },
            features: {
                active: true,
                tooltip: {
                    active: true,
                    template: '<p class="title">:code</p>',
                },
                acl: {
                    view: 'MB_00636',
                },
            },
        },
        states: {
        },
        filters: {
        },
        map: {
            loading: false,
            reload: false,
            action: null,
            user_feature: null,
            filters: {
                types: [],
                status: [],
            },
            config: {
                layers: {
                    features: {
                        scale: .5,
                        scaleSelected: 1,
                    },
                },
                interactions: {
                    draw: {
                    },
                },
            }
        },
    },
};

export default state;